import React from 'react';
import { Card, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import UserManagement from './admin/UserManagement';
import './AdminPanel.css';

const { Title } = Typography;

const AdminUsers = () => {
  return (
    <AppLayout activeMenu="/admin/users">
      <Card className="admin-content-card">
        <div className="admin-content-header">
          <Title level={3} style={{ margin: 0 }}>
            <TeamOutlined style={{ marginRight: 12, color: '#13c2c2' }} />
            User Management
          </Title>
          <p style={{ margin: '8px 0 0 0', color: '#666' }}>
            Manage admin users, verifiers, and permissions
          </p>
        </div>
        <UserManagement embedded />
      </Card>
    </AppLayout>
  );
};

export default AdminUsers;
